import React, { useEffect, useState, useMemo } from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { authSelector } from "../../apps/auth";
import Sidebar from "../../common/Sidebar";
import { HashLoader } from "react-spinners";
import { useDispatch, useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import { xtreamSelector, changeLimit, changePage, fetchXtreams, fetchXtreamDetail } from "../../apps/xtream";
import { pageOptions } from "../../utils/constants";

const XtreamList = () => {
    const dispatch = useDispatch();
    const { token } = useSelector(authSelector);
    const { xtreams, total, limit, page, xtreamDetail } = useSelector(xtreamSelector);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const [showTimeSpendModal, setShowTimeSpendModal] = useState(false);
    const handleClose = () => setShowTimeSpendModal(false);

    const pageCount = useMemo(() => {
        const pageCounter = Math.ceil(total / limit);
        return pageCounter;
    }, [total, limit]);

    const [configObject] = useState({
        headers: {
            Authorization: "Bearer " + token,
        },
        params: {
            limit: limit,
            page: page,
            keyword: searchTerm
        },
    });

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        try {
            await dispatch(fetchXtreams({
                ...configObject, params: {
                    limit: limit,
                    page: page,
                    keyword: searchTerm
                },
            }));
        } catch (err) {
        } finally {
            setLoading(false);
        }
    };

    const limtHandler = async (e) => {
        await dispatch(changeLimit(e.target.value));
        await dispatch(fetchXtreams({
            ...configObject, params: {
                limit: e.target.value,
                page: 1,
                keyword: searchTerm
            },
        }));
    }

    const handlePageClick = async (data) => {
        const currentpage = data.selected + 1;
        await dispatch(changePage(currentpage));
        await dispatch(fetchXtreams({
            ...configObject, params: {
                limit: limit,
                page: currentpage,
                keyword: searchTerm
            },
        }));
    };

    const viewDetail = async (xtreamId) => {
        setLoading(true);
        setShowTimeSpendModal(true);
        try {
            await dispatch(fetchXtreamDetail({
                ...configObject, params: {
                    xtreamId: xtreamId,
                },
            }));
        } catch (err) {
        } finally {
            setLoading(false);
        }
    }

    console.log(page);

    return (
        <>
            <Sidebar />
            {loading ? (
                <div className="spinner">
                    <HashLoader color="#757575" size={75} loading={true} />
                </div>
            ) : (
                <div className="card shadow-sm rounded">
                    {/* Header */}
                    <div className="card-header bg-white d-flex justify-content-between align-items-center">
                        <h3 className="mb-0">Xtreams</h3>

                        <div className="d-flex align-items-center gap-3">
                            <input
                                className="form-control form-control-sm"
                                style={{ minWidth: "200px" }}
                                placeholder="Search"
                                onChange={(e) => setSearchTerm(e.target.value)}
                                value={searchTerm}
                                type="search"
                            />
                            <Button className="btn search_btn" onClick={fetchData}>Search</Button>
                        </div>
                    </div>

                    {/* Table */}
                    <div className="table-responsive">
                        <Table
                            striped
                            bordered
                            hover
                            size="sm"
                            className="align-middle mb-0"
                        >
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Name</th>
                                    <th>URL</th>
                                    <th>Device Model</th>
                                    <th>Device OS</th>
                                    <th>Connected</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {total > 0 ? (
                                    xtreams.map((item) => (
                                        <tr key={item?._id}>
                                            <td>{item?._id}</td>
                                            <td>{item?.name}</td>
                                            <td>
                                                <a
                                                    href={item?.url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-primary text-decoration-none"
                                                >
                                                    {item?.url}
                                                </a>
                                            </td>
                                            <td>{item?.device?.device_model}</td>
                                            <td>{item?.device?.os_version}</td>
                                            <td>{item?.connected}</td>
                                            <td>
                                                <button className="btn action_btn" onClick={() => viewDetail(item?._id)}>
                                                    <i className="fa fa-eye"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center text-muted py-4">
                                            No record found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>

                    {/* Pagination & Limit Dropdown */}
                    {total > 0 && (
                        <div className="d-flex flex-wrap justify-content-between align-items-center px-3 py-3 border-top">
                            {/* Limit Selector */}
                            <div className="d-flex align-items-center gap-2">
                                <label className="mb-0 small">Show:</label>
                                <select className="form-select form-select-sm" onChange={limtHandler} value={limit}>
                                    {pageOptions.map((page) => (
                                        <option value={page.value} key={page.label}>
                                            {page.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Pagination */}
                            <ReactPaginate
                                previousLabel={"‹"}
                                nextLabel={"›"}
                                breakLabel={"..."}
                                pageCount={pageCount === 1 ? 1 : pageCount}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={3}
                                onPageChange={handlePageClick}
                                containerClassName={"pagination mb-0"}
                                pageClassName={"page-item"}
                                pageLinkClassName={"page-link"}
                                previousClassName={"page-item"}
                                previousLinkClassName={"page-link"}
                                nextClassName={"page-item"}
                                nextLinkClassName={"page-link"}
                                breakClassName={"page-item"}
                                breakLinkClassName={"page-link"}
                                activeClassName={"active"}
                                forcePage={page - 1} // keeps active page in sync on refresh
                            />
                        </div>
                    )}
                </div>
            )}

            <Modal show={showTimeSpendModal} size="md" onHide={handleClose}>
                <Modal.Header closeButton>{xtreamDetail?.url} Spend Time (in Hrs)</Modal.Header>
                <Modal.Body>
                    <Table striped
                        bordered
                        hover className="align-middle mb-0">
                        <tbody>
                            <tr>
                                <th>Username</th>
                                <td>{xtreamDetail?.username}</td>
                            </tr>
                            <tr>
                                <th>Password</th>
                                <td>{xtreamDetail?.password}</td>
                            </tr>
                            <tr>
                                <th>Movies</th>
                                <td>{xtreamDetail?.timeSpent?.movies ?? 0}</td>
                            </tr>
                            <tr>
                                <th>Series</th>
                                <td>{xtreamDetail?.timeSpent?.series ?? 0}</td>
                            </tr>
                            <tr>
                                <th>Live Channels</th>
                                <td>{xtreamDetail?.timeSpent?.liveChannel ?? 0}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Modal.Body>
            </Modal>
        </>
    );
};
export default XtreamList;
